// headerColorChanges
window.headerColors = {
  'DRB': { background: '#948984', color: 'white' },
  'RT202': { background: '#000000', color: 'white' },
  'AAC': { background: '#d2a852', color: 'white' }
};

//Primary Color Change, Text, and Hover
window.buttonColors = {
  'DRB': {
    background: '#948984',
    color: 'white',
    hoverBackground: '#7a726d',
    hoverColor: '#ffffff'
  },
  'RT202': {
    background: '#000000',
    color: 'white',
    hoverBackground: '#333333',
    hoverColor: '#ffffff'
  },
  'AAC': {
    background: '#d2a852',
    color: 'white',
    hoverBackground: '#b68b42',
    hoverColor: '#ffffff'
  }
};


// Footer Color Change and Text
window.footerColors = {
  'DRB': {
    background: '#bcbbb9',
    color: 'white',
  },
  'RT202': {
    background: '#d4d4d4',
    color: 'white',
  },
  'AAC': {
    background: '#d5b485',
    color: 'white',
  }
};